// extracted by mini-css-extract-plugin
export default {"loader":"loader-dots_loader__0TBUk","l4":"loader-dots_l4__GxK9q"};